import { simpleLookupConfig } from "../../../../records/lookup/config/simpleLookupConfig";
import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

export const vsObjectName = "machineGameFamily";

const url = "/api/machines/MachineGameFamily";

export const machineGameFamilyLookupConfig = simpleLookupConfig(
  vsLookupManagementServiceProviderName,
  {
    name: vsObjectName,
    nameSingular: "Game Family",
    url,
  }
);
